import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TextField from "@mui/material/TextField";
import { Calendar } from "primereact/calendar";
import { alertActions, ProductVenderMappingActions } from "../../actions";
import { connect } from "react-redux";
import tableRequest from "../../models/tableRequest.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CSVLink } from "react-csv";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import FormControl from "@mui/material/FormControl";
import { SecondaryPackingReport } from "../../reducers/SecondaryPackingRptReducer.js";

class ProductVenderMapping extends Component {
  constructor(props) {
    super(props);
    this.csvLink = React.createRef();
    this.tblResponse = new tableRequest();
    this.tblResponse.PageSize = 5;
    this.tblResponse.SortColumn = "CreatedDt";
    this.tblResponse.SortOrder = "DESC";
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.UploadMapping = this.UploadMapping.bind(this);
    this.FilterData = this.FilterData.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.Export = this.Export.bind(this);
    this.fileInput = React.createRef();
    this.templateCsvLink = React.createRef();
    this.state = {
      loading: false,
      FromDate: new Date(),
      ToDate: new Date(),
      first: 0,
      rows: 5,
      selectedFileName: "",
      totalRecords: 0,
      //totalRecords: props.secondaryitems?.length || 0,
      globalFilter: "",
      filteredData: props.secondaryitems || [],
      visible: false,
      sortOrder: "",
      datalist: [],
      UserId: 0,
      ProductId: 0,
      ProductDDL: [],
      Reason: "",
      formError: {},
      headersTemplate: [
        { label: "VendorName", key: "VenderName" },
        { label: "ProductNames", key: "ProductNames" },
      ],
      headers: [
        { label: "Vendor Name", key: "VenderName" },
        { label: "Product Names", key: "ProductNames" },
        { label: "Created Date", key: "CreatedDt" },
      ],
    };
  }
  // validateForm = () => {
  //   const { ProductDDL } = this.state;
  // const errors = {};
  // let isValid = true;
  // if (ProductDDL.length === 0) {
  //   errors.ProductDDL = "Please select at least one product.";
  //   isValid = false;
  // }
  // this.setState({ formError: errors || {} }); // Ensure formError is always set
  // return isValid;
  // };
  downloadTemplate = () => {
    this.templateCsvLink.current.link.click();
  };
  UploadMapping(event) {
    event.preventDefault();
    const user = JSON.parse(sessionStorage.getItem("user"));
    const userId = user ? user.UserId : null;
    let isfrmvalid =
      document.querySelector('input[type="file"]').files &&
      document.querySelector('input[type="file"]').files[0] != null
        ? true
        : false;
    var file = document.querySelector('input[type="file"]').files[0];

    if (isfrmvalid) {
      var data = new FormData();
      data.append("Inputfile", file);
      data.append("CreatedBy", this.state.UserId);
      this.props.UploadMapping(data, this.tblResponse);
      this.fileInput.current.value = "";
      this.setState({ selectedFileName: "" });
      setTimeout(() => {
        // this.resetForm();
      }, 1000);
    } else {
    }
  }
  componentDidMount() {
    //debugger;
    var date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - 7);
    this.tblResponse.FromDate = date.toDateString("mm/dd/yyyy");
    this.tblResponse.ToDate = new Date().toDateString("mm/dd/yyyy");
    this.setState({
      FromDate: date,
      ToDate: new Date(),
    });
    this.tblResponse.DealerId = this.state.UserId;
    this.props.fetchApi(this.tblResponse);
    this.props.GetVendorListDDL(sessionStorage.getItem("UserData"));
    this.props.GetProductDDl();
    //this.props.GetVendorProduct();
  }

  componentDidUpdate(prevProps) {
    console.log("Vendor Products:", this.props.VendorProducts);
    // if (prevProps.secondaryitems !== this.props.secondaryitems) {
    //   this.setState({ filteredData: this.props.secondaryitems });
    // }
    if (prevProps.VendorProducts !== this.props.VendorProducts) {
      const productIds = this.props.VendorProducts.map((p) => p.value);
      this.setState({ VendorProducts: productIds });
      //this.setState({ProductDDL: productIds});
      //this.setState({ ProductDDL: [] });
    }
    // if (this.state.UserId) {
    //   console.log('data', this.state.ProductDDL);
    //   console.log('Vendor Data', this.state.UserId)
    // }
    if (
      this.state.Download &&
      this.props.IsDownload >= 1 &&
      prevProps.IsDownload !== this.props.IsDownload
    ) {
      setTimeout(() => {
        this.csvLink.current.link.click();
        this.setState({ Download: false });
      }, 1000);
    }
    if (prevProps.SecondaryPackingList !== this.props.SecondaryPackingList) {
      // this.props.myProp has a different value
      if (this.props.SecondaryPackingList) {
        var e = this.props.SecondaryPackingList;
        this.setState({
          totalRecords: parseInt(e[0].TotalRows),
        });
      }
    }
    ////////
    // if (prevProps.ProductVenderMapping !== this.props.ProductVenderMapping) {
    //   if (this.props.ProductVenderMapping) {
    //     var e = this.props.ProductVenderMapping;
    //     this.setState({
    //       totalRecords: parseInt(e[0].TotalRows)
    //     });
    //   }
    // }
    // if(prevProps.secondaryitems !==this.propssecondaryitems){
    //   if(this.props.secondaryitems){
    //     var e= this.props.secondaryitems;
    //     this.setState({
    //       totalRecords: parseInt(e[0].TotalRows)
    //     });
    //   }
    // }
    if (
      prevProps.ProductVenderMapping !== this.props.ProductVenderMapping &&
      this.props.ProductVenderMapping
    ) {
      this.setState({
        Reason: this.props.ProductVenderMapping.Reason || "",
      });
    }

    if (
      this.state.Download &&
      this.props.IsDownload >= 1 &&
      prevProps.IsDownload != this.props.IsDownload
    ) {
      setTimeout(() => {
        this.csvLink.current.link.click();
      }, 3000);
      this.setState({
        Download: false,
      });
    }
  }

  GetOrderBooking() {
    let ToDt = new Date();
    let FrmDt = new Date();
    FrmDt.setDate(ToDt.getDate() - 7);
    const myFmDt = this.getCurrentDateYYYYMMDD(FrmDt);
    const myToDt = this.getCurrentDateYYYYMMDD(ToDt);
    this.tblResponse.FromDate = myFmDt;
    this.tblResponse.ToDate = myToDt;
    this.props.fetchApi(this.tblResponse);
  }

  FilterData() {
    this.tblResponse.FromDate = this.state.FromDate.toDateString("mm/dd/yyyy");
    this.tblResponse.ToDate = this.state.ToDate.toDateString("mm/dd/yyyy");
    this.tblResponse.DealerId = this.state.UserId;
    this.props.fetchApi(this.tblResponse);
  }

  filterData = (filterValue) => {
    //debugger;
    const { secondaryitems } = this.props;

    if (!filterValue) {
      // If empty, reset to full list
      this.setState({ filteredData: secondaryitems, globalFilter: "" });
      return;
    }
    const filteredItems = secondaryitems.filter(
      (item) =>
        (item.VenderName?.toLowerCase().trim() || "").includes(
          filterValue.toLowerCase().trim()
        ) ||
        (item.ProductNames?.toLowerCase().trim() || "").includes(
          filterValue.toLowerCase().trim()
        )
    );
    this.setState({
      globalFilter: filterValue,
      filteredData: filteredItems,
      //totalRecords: filteredItems.length,
    });
  };
  getCurrentDateYYYYMMDD(dt) {
    var dd = String(dt.getDate()).padStart(2, "0");
    var mm = String(dt.getMonth() + 1).padStart(2, "0");
    var yyyy = dt.getFullYear();
    dt = yyyy + "/" + mm + "/" + dd;
    return dt;
  }
  // handleChange(event) {
  //   const { name, value } = event.target || event;
  //   this.setState({ ProductDDL: event.target.value });
  //   switch (name) {
  //     case "FromDate":
  //       if (value === null || !(value instanceof Date)) {
  //         this.formIsValid = false;
  //         // this.refs.Messchild.showError("Please select from date.");
  //         this.toast.show({
  //           severity: "error",
  //           summary: "Error Message",
  //           detail: "Please select from date.",
  //           life: 3000,
  //         });
  //         return;
  //       } else if (
  //         !value.toDateString("mm/dd/yyyy").match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
  //       ) {
  //         this.formIsValid = false;
  //         this.toast.show({
  //           severity: "error",
  //           summary: "Error Message",
  //           detail: "Please enter only date.",
  //           life: 3000,
  //         });
  //         // this.refs.Messchild.showError("Please enter only date.");
  //         return;
  //       } else if (value instanceof Date && this.state.ToDate instanceof Date) {
  //         const startDate = value;
  //         const endDate = this.state.ToDate;
  //         if (!(Date.parse(startDate) <= Date.parse(endDate))) {
  //           this.formIsValid = false;
  //           this.toast.show({
  //             severity: "error",
  //             summary: "Error Message",
  //             detail: "From date must be less than to date.",
  //             life: 3000,
  //           });
  //           // this.refs.Messchild.showError("From date must be less than to date.");
  //           return;
  //         }
  //       }
  //       break;
  //     case "ToDate":
  //       if (value === null || !(value instanceof Date)) {
  //         this.formIsValid = false;
  //         this.toast.show({
  //           severity: "error",
  //           summary: "Error Message",
  //           detail: "Please select to date.",
  //           life: 3000,
  //         });
  //         // this.refs.Messchild.showError("Please select to date.");
  //         return;
  //       } else if (
  //         !value.toDateString("mm/dd/yyyy").match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
  //       ) {
  //         this.formIsValid = false;
  //         this.toast.show({
  //           severity: "error",
  //           summary: "Error Message",
  //           detail: "Please enter only date.",
  //           life: 3000,
  //         });
  //         // this.refs.Messchild.showError("Please enter only date.");
  //         return;
  //       } else if (
  //         value instanceof Date &&
  //         this.state.FromDate instanceof Date
  //       ) {
  //         const startDate = this.state.FromDate;
  //         const endDate = value;
  //         if (!(Date.parse(startDate) <= Date.parse(endDate))) {
  //           this.formIsValid = false;
  //           this.toast.show({
  //             severity: "error",
  //             summary: "Error Message",
  //             detail: "To date must be greater than from date.",
  //             life: 3000,
  //           });
  //           // this.refs.Messchild.showError("To date must be greater than from date.");
  //           return;
  //         }
  //       }
  //       break;
  //     default:
  //       break;
  //   }
  //   this.setState({ [name]: value });
  // }
  handleChange = (e) => {
    //this.setState({ [e.target.name]: e.target.value });
    this.setState({ ProductDDL: e.value });
  };
  //to lazy load
  getLazyLoadingValues(event) {
    //debugger;
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SearchValue=event.selected || " ";
    this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.DealerId = this.state.UserId;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.FromDate = this.state.FromDate.toDateString("mm/dd/yyyy");
    this.tblResponse.ToDate = this.state.ToDate.toDateString("mm/dd/yyyy");
  }
  onPage(event) {
    this.props.loadingData(true);
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      debugger;
      this.props.fetchApi(this.tblResponse);
    }, 250);
  }
  Export() {
    // debugger;
    //console.log("Data",this.props);
    this.tblResponse.PageSize = -1;
    this.tblResponse.First = 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue =
      this.state.globalFilter == null ? "" : this.state.globalFilter;
    this.tblResponse.SortColumn = "CreatedDt";
    this.tblResponse.DealerId = this.state.UserId;
    this.tblResponse.SortOrder = "DESC";
    this.tblResponse.FromDate = this.state.FromDate.toDateString("mm/dd/yyyy");
    this.tblResponse.ToDate = this.state.ToDate.toDateString("mm/dd/yyyy");
    this.props.exportData(this.tblResponse);
    this.setState({
      Download: true,
    });
  }
  submitForm = (e) => {
    //debugger;
    //this.props.fetchApi(this.tblResponse);
    e.preventDefault();
    const errors = {};
    if (!this.state.UserId) {
      errors.UserId = "Please select a vendor.";
    }
    if (!this.state.VendorProducts || this.state.VendorProducts.length === 0) {
      errors.ProductDDL = "Please select at least one product.";
    }
    // if(!this.state.VendorProducts || this.state.VendorProducts.length===0){
    //   errors.VendorProducts="Please select at least One product";
    // }
    this.setState({ formError: errors });
    if (Object.keys(errors).length > 0) {
      toast.error("Please fill all requird field.");
      return;
    }
    const user = JSON.parse(sessionStorage.getItem("user"));
    const userId = user ? user.UserId : null;
    const formData = {
      VenderId: this.state.UserId,
      ProductIds: this.state.VendorProducts.join(","),
      CreatedBy: userId,
    };
    debugger;
    this.props.createMapping(formData);
    this.tblResponse = new tableRequest();
    this.props.fetchApi(this.tblResponse);

    //  window.location.reload();
  
    this.setState({
      UserId: 0,
      VendorProducts: [],
      ProductDDL: [],
      formError: {},
    });
  };
  //to search
  searchFilter(e) {
    debugger;
    this.props.loadingData(true);
    this.setState({
      sortOrder: this.state.sortOrder === 1 ? 2 : 1,
      globalFilter: e.target.value,
    });
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.tblResponse.DealerId = this.state.UserId;
    this.tblResponse.FromDate = this.state.FromDate.toDateString("mm/dd/yyyy");
    this.tblResponse.ToDate = this.state.ToDate.toDateString("mm/dd/yyyy");
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
    //this.props.SecondaryPackingList;
  }
  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.tblResponse.DealerId = this.state.UserId;
    this.tblResponse.FromDate = this.state.FromDate.toDateString("mm/dd/yyyy");
    this.tblResponse.ToDate = this.state.ToDate.toDateString("mm/dd/yyyy");
    this.props.fetchApi(this.tblResponse);
  }

  ProductBody(rowData) {
    const ProductNames = rowData?.ProductNames ?? "";
    return (
      <div>
        {ProductNames.split(",").map((line, index) => (
          <span style={{ display: "block" }} key={index}>
            {line}
          </span>
        ))}
      </div>
    );
  }
  render() {
    
    return (
      <div className="datatable-filter-demo">
        <toast ref={(el) => (this.toast = el)} />
        <div className="row align-items-center mb-3">
  <div className="col-md-3">
    <h4 className="pl-2 mb-0">Product Vendor</h4>
  </div>

  <div className="col-md-9">
    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

      {/* Left group: buttons */}
      <div className="d-flex flex-wrap gap-2 align-items-center">
        <CSVLink
          data={[]}
          headers={this.state.headersTemplate}
          filename="ProductVendorMapping_Template.csv"
          ref={this.templateCsvLink}
          className="hidden"
        />
        <button
          onClick={this.downloadTemplate}
          className="btn btn-info p-2 px-3"
        >
          Download Template
        </button>

        <CSVLink
          data={this.props.List}
          headers={this.state.headers}
          filename="Product Vendor Mapping.csv"
          target="_blank"
          ref={this.csvLink}
        />

        <input
          type="file"
          accept=".csv"
          ref={this.fileInput}
          style={{ display: "none" }}
          onChange={(e) => {
            const file = e.target.files[0];
            this.setState({
              selectedFileName: file ? file.name : "",
            });
          }}
        />
        <button
          onClick={() => this.fileInput.current.click()}
          className="btn btn-secondary p-2 px-3"
        >
          Choose File
        </button>

        {this.state.selectedFileName && (
          <span className="ml-2 align-self-center">
            {this.state.selectedFileName}
          </span>
        )}

        <button
          type="button"
          onClick={this.UploadMapping}
          className="btn btn-primary p-2 px-3"
        >
          Upload
        </button>

        <button
          onClick={this.Export}
          className="btn btn-success p-2 px-3"
        >
          Export
        </button>
      </div>

      {/* Right group: search box */}
      <div style={{ minWidth: "200px" }}>
        <TextField
          id="standard-basic"
          size="small"
          variant="outlined"
          fullWidth
          label="Search"
          value={this.state.globalFilter}
          onChange={this.searchFilter}
        />
      </div>
    </div>
  </div>
</div>

        <div className="row">
          <div className="col-md-3">
            <Dropdown
              style={{
                width: "90%",
                backgroundColor: "#ffffff",
                borderColor: "#ced4da",
                color: "#495057",
              }}
              value={this.state.UserId}
              // onChange={(e) =>

              //   this.setState({
              //     UserId: e.value,
              //     formError: { ...this.state.formError, UserId: "" }
              //   })
              // }
              
              onChange={(e) => {
                const vendorId = e.value;
                 const selectedVendor = (this.props.VendorDDL.find(v => v.value === vendorId)?.label || '').split(' (')[0];   
              //console.log('Selected Vendor:', selected);
                this.setState({
                  UserId: vendorId,
                  ProductDDL: [], // Clear previous selections
                  formError: { ...this.state.formError, UserId: "" },
                });
                this.tblResponse.SearchValue = selectedVendor;
                this.props.GetVendorProduct(vendorId);
                this.props.fetchApi(this.tblResponse);
              }}              
              options={this.props.VendorDDL}
              optionValue="value"
              optionLabel="label"
              className="form-control custom-select"
              placeholder="Select Vendor"
              name="UserId"
              onClick={this.searchFilter}
             //onChange2={(e) => this.searchFilter(e.target.value)}
              filter
            />
            {this.state.formError.UserId && (
              <p className="text-danger small">{this.state.formError.UserId}</p>
            )}
          </div>
          <div className="col-md-3">
            <DataTable
              value={this.props.SecondaryPackingList} //chngs
              // value={this.state.filteredData}
              scrollable
              responsive={true}
              globalFilter={this.state.globalFilter}
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              emptyMessage="No Data found."
              sortMode="multiple"
              style={{ width: "100%" }}
              lazy={true}
              first={this.state.first}
              onPage={this.onPage}
              onSort={this.onSort}
              loading={this.props.loading}
              ref={(el) => {
                this.dt = el;
              }}
            ></DataTable>
            <div className="col-md-15">
              <FormControl
                fullWidth
                error={Boolean(this.state.formError.ProductDDL)}
                style={{ width: "90%" }}
              >
              <MultiSelect
                  debugger
                  style={{
                    backgroundColor: "#ffffff",
                    borderColor: "#ced4da",
                    color: "#495057",
                  }}
                  appendTo={document.getElementById("root")}
                  value={this.state.VendorProducts}
                  onChange={(e) => {
                    //debugger;
                    this.setState({ VendorProducts: e.value });
                  }}
                  options={this.props.ProductDDL}
                  optionValue="value"
                  optionLabel="label"
                  className="form-control"
                  placeholder="Select Products"
                  name="product"
                  filter
                  //display="chip"
                />
                {this.state.formError.ProductDDL && (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    {this.state.formError.ProductDDL}
                  </p>
                )}
              </FormControl>
            </div>
          </div>
          <div className="col-md-3">
            <button
              type="button"
              onClick={this.submitForm}
              className="btn btn-primary p-2 pl-2 pr-2 buttone"
            >
              Submit
            </button>
          </div>
        </div>
        <div className="card mb-5">
          <DataTable
            className="mb-2"
            value={this.props.SecondaryPackingList}
            //value={this.state.filteredData}
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            //header={header}
            emptyMessage1="No data found"
            emptyMessage="No data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            rowsPerPageOptions={[5, 10, 200]}
            totalRecords={parseInt(this.state.totalRecords || 0)}
            // totalRecords={this.state.totalRecords || 0}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
          >
            <Column
              style={{ width: "20%" }}
              field="VenderName"
              header="Vendor Name"
            />
            <Column
              style={{ width: "50%" }}
              body={this.ProductBody}
              header="Product Name"
            />
            <Column
              style={{ width: "20%" }}
              field="CreatedDt"
              header="Created Date"
            />
          </DataTable>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  console.log("Data", state);
  return {
    secondaryitems: state.ProductVenderMapping?.secondaryitems || [],
    List: state.ProductVenderMapping.secondaryitems || [],
    IsDownload: state.ProductVenderMapping.isDownload,
    secondaryitems: state.ProductVenderMapping.secondaryitems || [],
    SecondaryPackingList: state.SecondaryPackingReport.secondaryitems,
    VendorDDL:
      state.SecondaryPackingReport.vendorDDL == undefined
        ? []
        : state.SecondaryPackingReport.vendorDDL,
    List:
      state.ProductVenderMapping.exportitems == undefined
        ? []
        : state.ProductVenderMapping.secondaryitems,
    loading: state.ProductVenderMapping.loding,
    IsDownload: state.ProductVenderMapping.isDownload,
    secondaryitems:
      state.SecondaryPackingReport.secondaryitems == undefined
        ? []
        : state.SecondaryPackingReport.secondaryitems,
    ProductDDL: state.ProductVenderMapping.ProductDDList || [],
    VendorProducts: state.ProductVenderMapping.VendorProducts || [],
    // Reason:state.ProductVenderMapping.Reason
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    //debugger;
    fetchApi: (obj) => {
      dispatch(ProductVenderMappingActions.getAll(obj));
    },
    loadingData: (isLoding) =>
      dispatch(ProductVenderMappingActions.loadingData(isLoding)),
    exportData: (obj) => dispatch(ProductVenderMappingActions.exportData(obj)),
    GetVendorListDDL: (UserId) =>
      dispatch(ProductVenderMappingActions.GetVendorListDDL(UserId)),
    GetVendorProduct: (UserId) =>
      dispatch(ProductVenderMappingActions.GetVendorProduct(UserId)),
    GetProductDDl: () => {
      dispatch(ProductVenderMappingActions.ProductDDL());
    },
    createMapping: (user) =>
      dispatch(ProductVenderMappingActions.createMapping(user)),
    UploadMapping: (obj, tblResponse) => {
      dispatch(ProductVenderMappingActions.UploadMapping(obj, tblResponse));
    },
    
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductVenderMapping);
